import { queryOptions, useSuspenseQuery } from '@tanstack/react-query';

import type { QueryConfig } from '@/lib/react-query';
import { api, extractData } from '@/lib/treaty';

export type TenantWithUsers = NonNullable<
  Awaited<ReturnType<ReturnType<typeof api.tenants>['users']['get']>>['data']
>;

type TenantId = TenantWithUsers['id'];
export type TenantEmployees = TenantWithUsers['employees'];
export type TenantContacts = TenantWithUsers['contacts'];
export type TenantTokens = TenantWithUsers['tokens'];

type TenantUsersQueryOptions = {
  queryConfig?: QueryConfig<typeof getTenantUsers>;
  id: TenantId;
};

const getTenantUsers = (id: TenantId) => {
  return extractData(api.tenants({ id }).users.get());
};

export const getTenantUsersOptions = (id: TenantId) => ({
  queryKey: ['tenants', id, 'users'],
  queryFn: () => getTenantUsers(id),
});

export const getTenantUsersQueryOptions = (id: TenantId) => {
  return queryOptions(getTenantUsersOptions(id));
};

export const useTenantUsers = ({ queryConfig, id }: TenantUsersQueryOptions) => {
  return useSuspenseQuery({ ...queryConfig, ...getTenantUsersQueryOptions(id) });
};
